import _styled from "../../_snowpack/pkg/styled-components.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState } from '../../_snowpack/pkg/react.js';
import { DndProvider } from '../../_snowpack/pkg/react-dnd.js';
import { HTML5Backend } from '../../_snowpack/pkg/react-dnd-html5-backend.js';
import { ApolloProvider } from '../../_snowpack/pkg/@apollo/react-hooks.js';
import * as Sentry from '../../_snowpack/pkg/@sentry/browser.js';
import { ThemeProvider } from '../../_snowpack/pkg/styled-components.js';
import { BrowserRouter as Router } from '../../_snowpack/pkg/react-router-dom.js';
import config from '../app-config.js';
import { Button } from '../css/index.js';
import { FeedbackWrapper } from '../modules/feedback.js';
import ApiHealthyGate from '../gates/api-healthy-gate.js';
import { FeatureFlagsGate } from '../gates/feature-flags-gate.js';
import AuthGate, { redirectForAuthenticatedSession } from '../gates/auth-gate/index.js';
import DebugBar from '../modules/debug-bar/index.js';
import ErrorScreen from '../modules/error-screen/index.js';
import GlobalStyle, { theme } from '../css/global.js';
import MediaGate from '../gates/media-gate.js';
import { MediasDnDContextProvider } from '../modules/medias-dnd/index.js';
import { UserProvider } from '../hooks/user-context.js';
import getUserConfirmation from '../modules/user-confirmation/index.js';
import ApiUnHealthy from '../images/illustrations/api-unhealthy.svg';
import { DropdownMenuProvider } from '../components/dropdown-menu/context.js';
import AppVersionManager from './app-version.js';
import { setupClient } from './graph-client.js';
import Routes from '../routes.js';
import '../../_snowpack/pkg/react-day-picker/lib/style.css';
import '../css/form/date-picker/react-day-picker-override.css';
import UsageAlert from './budget-alert/index.js';

function Inner() {
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  function onNotAuthenticated() {
    setIsAuthenticated(false);

    if (!location.pathname.match(/^\/sign(in|up)/)) {
      window.location = `${config.API_URL}/signin?redirect=${encodeURIComponent(location.href)}`;
    } else {
      const url = new URL(location.href);
      redirectForAuthenticatedSession.save(url.searchParams.get('redirect'));
    }
  }

  function onAuthenticated() {
    const redirect = redirectForAuthenticatedSession.get();

    if (redirect) {
      redirectForAuthenticatedSession.clear();
      window.location.href = redirect;
    }
  }

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(DndProvider, {
    backend: HTML5Backend
  }, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(ApolloProvider, {
    client: setupClient({
      onNotAuthenticated,
      onAuthenticated
    })
  }, /*#__PURE__*/React.createElement(UserProvider, null, /*#__PURE__*/React.createElement(AuthGate, null, /*#__PURE__*/React.createElement(ApiHealthyGate, null, /*#__PURE__*/React.createElement(FeatureFlagsGate, null, /*#__PURE__*/React.createElement(MediaGate, null, /*#__PURE__*/React.createElement(MediasDnDContextProvider, null, /*#__PURE__*/React.createElement(AppVersionManager, null), /*#__PURE__*/React.createElement(UsageAlert, null), /*#__PURE__*/React.createElement(FeedbackWrapper, null), /*#__PURE__*/React.createElement(DropdownMenuProvider, null, /*#__PURE__*/React.createElement(Routes, {
    isAuthenticated: isAuthenticated
  })), /*#__PURE__*/React.createElement(DebugBar, null))))))))));
}

var _StyledDiv = _styled("div").withConfig({
  displayName: "application___StyledDiv",
  componentId: "cd7qrc-0"
})(["margin:60px 0;"]);

export default class Application extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      error: null,
      eventId: null
    });

    _defineProperty(this, "reportErrorFeedback", () => {
      Sentry.showReportDialog({
        eventId: this.state.eventId
      });
    });
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error
    });
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({
        eventId
      });
    });
  }

  render() {
    const {
      error
    } = this.state;

    if (error) {
      return /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(ErrorScreen, {
        heading: "Oh dear, an error has occurred!",
        image: ApiUnHealthy
      }, /*#__PURE__*/React.createElement(_StyledDiv, null, "We are so terribly sorry for the inconvenience.", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("br", null), " If you have 1 minute to give us feedback on how this happened, we would be forever grateful"), /*#__PURE__*/React.createElement(Button, {
        onClick: this.reportErrorFeedback
      }, "Report feedback")));
    }

    return /*#__PURE__*/React.createElement(Router, {
      getUserConfirmation: getUserConfirmation
    }, /*#__PURE__*/React.createElement(Inner, null));
  }

}